(function($, undefined) {
    "use strict";

    let utils;

    // Initialize the utils variable
    function init() {
        utils = Fw.component.models().utils;
        $('.activate-btn').on('click', onActivateClick);
        $('#deleteallnotif').on('click', onDeleteNotif);
    }

    // Activate button click handler
    function onActivateClick(e) {
        const { id, type } = e.currentTarget.dataset;
        console.log(`Button clicked. ID: ${id}, Type: '${type}'`);

        const { updatePersonFields, updateGenDataFields } = utils;
        const onComplete = () => window.location.reload(true);

        if (type === 'user') {
            console.log('Updating person fields...');
            updatePersonFields(['field10'], ['account-validated'], id, onComplete);
        } else if (type === 'location') {
            console.log('Updating general data fields...');
            updateGenDataFields(id, ['field12'], ['true'], onComplete);
        } else if (type === 'notification') {
            console.log('Updating general data fields...');
            updateGenDataFields(id, ['field8'], ['true'], onComplete);
        }
    }

    // Delete all selected notifications
    function onDeleteNotif(e) {
        const onComplete = () => window.location.reload(true);

        // Select all the checkboxes
        const rowCheckboxes = document.querySelectorAll(".checkbox_notif_class");
        const selectedCheckboxes = Array.from(rowCheckboxes).filter(checkbox => checkbox.checked);

        // Check if any checkboxes are selected
        if (selectedCheckboxes.length === 0) {
            alert("No notifications selected for deletion.");
            return;
        }

        let completedRequests = 0;

        // Loop through selected checkboxes and perform the update operation
        selectedCheckboxes.forEach(checkbox => {
            const id = checkbox.id;
            const type = "notification";

            // Update gen data fields for each notification
            utils.updateGenDataFields(id, ["field8"], ["true"], () => {
                completedRequests++;

                // Once all requests are complete, reload the page
                if (completedRequests === selectedCheckboxes.length) {
                    location.reload();
                }
            });
        });
    }

    // Initialize the event listeners
    $(init);

})(jQuery);
